//src/components/Order.jsx
import React from "react";
import Explore from "./Explore";
function Order() {
  return (
    <div>
     <Explore/>
    </div>
  );
}

export default Order;
